var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "400" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("sale-detail-image")))]),
      _c(
        "w-card-content",
        [
          _vm.state.selectedRow.CoverImageOverrideFileID ||
          _vm.state.selectedRow.Product?.CoverImageID
            ? _c("div", {
                staticClass: "image-box",
                style: { backgroundImage: "url(" + _vm.fileUrl + ")" },
              })
            : _vm._e(),
          _c("app-file-upload", {
            attrs: {
              "max-size": 25000000,
              "allowed-extensions": _vm.allowedExtensions,
              label: _vm.$ct("upload-file"),
            },
            on: {
              input: function ($event) {
                return _vm.onFile($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _vm.state.selectedRow.CoverImageOverrideFileID
            ? _c(
                "w-button",
                {
                  staticClass: "mrs danger",
                  on: {
                    click: function ($event) {
                      return _vm.clearImage()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.delete")) + " ")]
              )
            : _vm._e(),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.continue")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }